import axios from 'axios'
import * as actions from '../../actionTypes'

const GET_CURRENT_MASTER_NUMBER = 'GET_CURRENT_MASTER_NUMBER'
const GET_CURRENT_MASTER_NUMBER_SUCCESS = 'GET_CURRENT_MASTER_NUMBER_SUCCESS'
const GET_CURRENT_MASTER_NUMBER_FAILURE = 'GET_CURRENT_MASTER_NUMBER_FAILURE'

const baseURL = process.env.REACT_APP_SERVICE_URL

const initialState = {
  isMasteNumberValid: false,
}
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT
const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_MASTER_NUMBER_SUCCESS:
      return {
        ...state,
        isMasteNumberValid: action.payload.isMasteNumberValid,
      }
    case GET_CURRENT_MASTER_NUMBER:
    case GET_CURRENT_MASTER_NUMBER_FAILURE: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

export const getmasterNumberValidAction = (masterNumber) => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_MASTER_NUMBER })
    return instance.post(`${baseURL}services/rmvservice/api/validateMasterNumber`, { masterNumber }).then(
      (response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_CURRENT_MASTER_NUMBER_SUCCESS,
            payload: {
              isMasteNumberValid: response['data']['responseCode'] === 0,
            },
          })
          return response
        } else {
          dispatch({ type: GET_CURRENT_MASTER_NUMBER_FAILURE })
        }
      },
      (err) => {
        dispatch({ type: GET_CURRENT_MASTER_NUMBER_FAILURE })
        throw new Error(`Error in validating master number with back-end`)
      }
    )
  }
}
